import * as React from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import { Box, ListItemText } from "@mui/material";

export default function Review({ shippingDetails, paymentDetails }) {
  const [cartItems, setCartItems] = React.useState([]);
  const [nameItems, setNameItems] = React.useState();
  const [priceItems, setPriceItems] = React.useState();

  React.useEffect(() => {

    setNameItems(localStorage.getItem("name"));
    setPriceItems(localStorage.getItem("totalprice"));
    console.log(localStorage.getItem(priceItems));
  }, []);

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Order summary
      </Typography>
      <List disablePadding>
        <Box sx={{display:'flex',justifyContent:'space-between'}}>
          {" "}
          <p> {nameItems}</p>
          <p>Rs. {priceItems}</p>
        </Box>

        {/* {products.map((product) => (
          <ListItem key={product.name} sx={{ py: 1, px: 0 }}>
            <ListItemText primary={product.name} secondary={product.desc} />
            <Typography variant="body2">{product.price}</Typography>
          </ListItem>
        ))} */}
        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Total" />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Rs. {priceItems}
          </Typography>
        </ListItem>
      </List>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Shipping
          </Typography>
          <Typography gutterBottom>
            Full Name: {shippingDetails.firstName} {shippingDetails.lastName}
          </Typography>
          <Typography gutterBottom>
            Shipping Address: {shippingDetails.address1} {shippingDetails.city}{" "}
            {shippingDetails.country}
          </Typography>
        </Grid>
        <Grid item container direction="column" xs={12} sm={6}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Payment details
          </Typography>
          <Grid container>
            <Grid item xs={12}>
              <Typography gutterBottom>
                {" "}
                Card Name :{paymentDetails.cardName}
              </Typography>

              <Typography gutterBottom>
                {" "}
                Card Number: {paymentDetails.cardNumber}
              </Typography>

              <Typography gutterBottom>
                Card Expiry: {paymentDetails.expDate}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
